import React, { FunctionComponent, useState, useEffect } from 'react';
import { useTheme } from '@mui/material/styles';
// import { useNavigate, useLocation } from 'react-router-dom';
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { useAtom } from 'jotai';
import { useTranslation } from 'react-i18next'
// import useMediaQuery from '@mui/material/useMediaQuery';

// import { check_subdomain } from '../../../lib/server_helper';
import { fetch_one, fetch_all } from "../../../lib/v31lib";
import { loginAtom } from '../../../lib/auth';
// import { currentPracticeAtom } from '../../../lib/practice';

import CloseIcon from '@mui/icons-material/Close';
import PanToolAltIcon from '@mui/icons-material/PanToolAlt';
import Logo from '../../../images/logo_nutriportal2024.png';

import {
  Avatar,
  CircularProgress,
  Divider,
  Grid,
  List,
  ListItem,
  ListItemAvatar,
  ListItemSecondaryAction,
  ListItemText,
  Paper,
} from '@mui/material';

import {
  Button,
  IconButton,
  Switcher,
  Typography
} from '../../../components/v2/styled';
import { SnackSaved } from '../../../components/v2/snacks/Saved';

import { Consent } from '../../../models/Consent';
import { User } from '../../../models/User';

// const { DateTime } = require("luxon");

type Props = {}

export const ClientSettingsDashboard: FunctionComponent<Props> = ({}) => {
  const [login, setLogin] = useAtom(loginAtom);
  // const [currentPractice, setCurrentPractice] = useAtom(currentPracticeAtom);
  const theme = useTheme();
  // const navigate = useNavigate();
  const {t, i18n} = useTranslation(['translations']);
  // const queryClient = useQueryClient();
  // const { state } = useLocation();

  const [extendedUser, setExtendedUser] = useState<User>();
  const [savedOpen, setSavedOpen] = useState<boolean>(false);
  const [overrideTheme, setOverrideTheme] = useState<{
    id?: string;
    primary_main: string;
    contrast_main: string;
    tertiary_main: string;
    onboarding_bg?: string;
    primary_main_light?: string;
    primary_main_dark?: string;
    tertiary_main_light?: string;
    tertiary_main_dark?: string;
    text_colour?: string;
  }|undefined>(undefined);

  const fields = [
    'id', 'first_name', 'last_name', 'auth_token', 'email', 'is_admin', 'extra_data', 'get_item_thumb', 'type', 'settings', 'goal_weight',
    'practice|id/name/item_is_square/get_medium', 'full_move_groups', 'full_eat_groups', 'calendar_url', 'second_name', 'call_name', 'birth_date',
    'gender', 'spouse_name', 'national_number', 'street', 'number', 'zip', 'city', 'country_id', 'phone_mobile', 'phone_fixed', 'extra_data', 'override_theme'
  ];

  const {
    data: extendedUserTemp,
    isLoading: extendedUserLoading,
    isError: extendedUserError,
    isSuccess: extendedUserSuccess,
    refetch: aextendedUserRefetch,
  } = useQuery({
    queryKey: ["advices", login?.id],
    queryFn: () =>
      fetch_one<User>(
        `/${i18n.resolvedLanguage || 'nl'}/v3/objects/fetch_all`,
        {
          object: 'user',
          fields: fields,
          id: login?.id
        },
        login
      ),
      // select: (d) => {
      //   return d.custom_result;
      // },
    enabled: !!login,
  });
  const {
    data: myPractices,
    // isLoading: objectsLoading,
    // isError: objectsError,
    // isSuccess: objectsSuccess,
    // refetch: objectsRefetch,
  } = useQuery({
    queryKey: ["my_practice_themes", login?.practice_id],
    queryFn: () =>
      fetch_all<Consent>(
        `/${i18n.resolvedLanguage || 'nl'}/v3/objects/fetch_all`,
        {
          object: 'consent',
          fields: ['id', 'practice', 'enabled'],
          sub_fields: {
            practice: ['id', 'name', 'get_medium', 'custom_theme']
          },
          filter: {
            search: '',
            advanced: {
              user_id: login?.id
            }
          }
        },
        login
      ),
    enabled: !!login && login.type === "User::User"
  });






  const mutationSave = useMutation({
    mutationFn: (pars: {
      formData: any;
    }) => {
      return fetch_one<User>(
        `/${i18n.resolvedLanguage || 'nl'}/v3/objects/save`,
        pars.formData,
        login
      );
    },
    onMutate: (pars: {
      formData: any;
    }) => {
      // setIsEditPasswordError(false);
      // setEditPasswordSuccess(false);
      // setEditPasswordError(undefined);
      // setEditPasswordLoading(true);
      return true;
    },
    onError: (data, variables, context) => {
      // setIsEditPasswordError(true);
      // setEditPasswordError(data as any);
      // setEditPasswordLoading(false);
      return true;
    },
    onSuccess: (data, variables, context) => {
      aextendedUserRefetch();
      setSavedOpen(true);
      setLogin(data);
    },
  });








  const saveUser = () => {
    if (!!extendedUser) {
      mutationSave.mutate({
        formData: {
          object: 'user',
          id: extendedUser.id,
          fields: fields,
          ob: {
            id: extendedUser.id,
            extra_data: {
              dashboard: {
                ...(extendedUser?.extra_data?.dashboard || {})
              },
              override_theme: overrideTheme || {id: 'fluid'}
            }
          }
        }
      });
    }
  }

  useEffect(() => {
    if (!!extendedUserTemp) {
      setExtendedUser(extendedUserTemp);
      setOverrideTheme(extendedUserTemp.override_theme);
    }
  }, [extendedUserTemp]);

  return <Grid container spacing={2}>
    {!!extendedUserLoading && <Grid item xs={12} sx={{textAlign: 'center'}}>
      <CircularProgress />
    </Grid>}
    {!!extendedUser && <>
      {!login?.extra_data?.weight_trigger && <Grid item xs={12} sm={6}>
        <Paper sx={{
          padding: 2
        }}>
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <Typography variant="h5">{t("client.settings.notifications.account.title")}</Typography>
              <Divider />
            </Grid>
            <Grid item xs={12}>
              <Switcher
                id="hide_weight"
                caption={t("client.settings.dashboard.measures.weight.hide_weight")}
                backend
                value={!!extendedUser.extra_data?.dashboard?.hide_weight}
                onChange={(e) => {
                  setExtendedUser({
                    ...extendedUser,
                    extra_data: {
                      ...(extendedUser.extra_data || {}),
                      dashboard: {
                        ...(extendedUser.extra_data?.dashboard || {}),
                        hide_weight: e
                      }
                    }
                  });
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <Divider sx={{marginTop: 1}} />
              {!!mutationSave.isPending && <CircularProgress />}
              {!mutationSave.isPending && <Button
                id="save_profile"
                contained
                onClick={(e) => {
                  saveUser();
                }}
                label={t("client.general.buttons.submit", "Opslaan")}
                sx={{
                  marginTop: 1
                }}
              />}
            </Grid>
          </Grid>
        </Paper>
      </Grid>}

      <Grid item xs={12} sm={6}>
        <Paper sx={{
          padding: 2
        }}>
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <Typography variant="h5">{t("client.settings.themes.title")}</Typography>
              <Divider />
            </Grid>
            <Grid item xs={12}>
              <Typography variant="body1">{t("client.settings.themes.explanation")}</Typography>
            </Grid>
            <Grid item xs={12}>
              <List>
                <ListItem
                  divider
                  selected={!overrideTheme || overrideTheme?.id === 'fluid'}
                  sx={{
                    cursor: 'pointer'
                  }}
                  onClick={(e) => {
                    e.preventDefault();
                    setOverrideTheme(undefined);
                  }}
                >
                  <ListItemAvatar>
                    <Avatar><CloseIcon /></Avatar>
                  </ListItemAvatar>
                  <ListItemText
                    primary={t("client.settings.themes.fluid_theme")}
                  />
                  <ListItemSecondaryAction>
                    <IconButton onClick={(e) => {
                      e.preventDefault();
                      setOverrideTheme(undefined);
                    }}>
                      <PanToolAltIcon />
                    </IconButton>
                  </ListItemSecondaryAction>
                </ListItem>
                <ListItem
                  divider
                  selected={overrideTheme?.id === "default"}
                  sx={{
                    cursor: 'pointer'
                  }}
                  onClick={(e) => {
                    e.preventDefault();
                    setOverrideTheme({
                      id: "default",
                      primary_main: '#97BE6B',
                      primary_main_dark: '#97BE6B',
                      primary_main_light: '#97BE6B',
                      contrast_main: '#FFFFFF',
                      tertiary_main: '#F9D971',
                      onboarding_bg: 'missing'
                    });
                  }}
                >
                  <ListItemAvatar>
                    <Avatar sx={{
                      backgroundColor: 'white',
                      border: '1px solid transparent',
                      borderColor: theme.palette.primary.main,
                      "& img": {
                        maxHeight: '100%',
                        maxWidth: '100%',
                        width: 'auto',
                        height: 'auto'
                      }
                    }} src={Logo}></Avatar>
                  </ListItemAvatar>
                  <ListItemText
                    primary={t("client.settings.themes.default_theme")}
                  />
                  <ListItemSecondaryAction>
                    <IconButton onClick={(e) => {
                      e.preventDefault();
                      setOverrideTheme({
                        id: "default",
                        primary_main: '#97BE6B',
                        primary_main_dark: '#97BE6B',
                        primary_main_light: '#97BE6B',
                        contrast_main: '#FFFFFF',
                        tertiary_main: '#F9D971',
                        onboarding_bg: 'missing'
                      });
                    }}>
                      <PanToolAltIcon />
                    </IconButton>
                  </ListItemSecondaryAction>
                </ListItem>
                
                {(myPractices || []).filter(fff => fff.enabled).map(practice => (<>
                  <ListItem
                    divider={(myPractices || []).indexOf(practice) < ((myPractices || []).length -1)}
                    selected={overrideTheme?.id === practice?.practice?.id?.toString()}
                    disabled={!(!!practice.practice?.custom_theme && !!practice.practice?.custom_theme.primary_main && !!practice.practice?.custom_theme.tertiary_main)}
                    sx={{
                      cursor: 'pointer'
                    }}
                    onClick={(e) => {
                      e.preventDefault();
                      if (!!practice.practice?.custom_theme && !!practice.practice?.custom_theme.primary_main && !!practice.practice?.custom_theme.tertiary_main) {
                        setOverrideTheme({
                          id: practice?.practice?.id?.toString(),
                          ...practice.practice?.custom_theme
                        });
                      }
                    }}
                  >
                    <ListItemAvatar>
                      <Avatar sx={{
                        backgroundColor: 'white',
                        border: '1px solid transparent',
                        borderColor: theme.palette.primary.main,
                        "& img": {
                          maxHeight: '100%',
                          maxWidth: '100%',
                          width: 'auto',
                          height: 'auto'
                        }
                      }} src={practice.practice?.get_medium} alt={practice.practice?.name}></Avatar>
                    </ListItemAvatar>
                    <ListItemText
                      primary={practice.practice?.name}
                      secondary={!!(!!practice.practice?.custom_theme && !!practice.practice?.custom_theme.primary_main && !!practice.practice?.custom_theme.tertiary_main) ? t("client.settings.themes.has_custom_theme") : t("client.settings.themes.no_custom_theme")}
                    />
                    <ListItemSecondaryAction>
                      <IconButton onClick={(e) => {
                        e.preventDefault();
                        if (!!practice.practice?.custom_theme && !!practice.practice?.custom_theme.primary_main && !!practice.practice?.custom_theme.tertiary_main) {
                          setOverrideTheme({
                            id: practice?.practice?.id?.toString(),
                            ...practice.practice?.custom_theme
                          });
                        }
                      }}>
                        <PanToolAltIcon />
                      </IconButton>
                    </ListItemSecondaryAction>
                  </ListItem>
                </>))}
              </List>
            </Grid>
            <Grid item xs={12}>
              <Divider sx={{marginTop: 1}} />
              {!!mutationSave.isPending && <CircularProgress />}
              {!mutationSave.isPending && <Button
                id="save_profile"
                contained
                onClick={(e) => {
                  saveUser();
                }}
                label={t("client.general.buttons.submit", "Opslaan")}
                sx={{
                  marginTop: 1
                }}
              />}
            </Grid>
          </Grid>
        </Paper>
      </Grid>
    </>}

    <SnackSaved open={savedOpen} setOpen={setSavedOpen} />
  </Grid>;
}

